import Sidebar from "../sidebar/Sidebar";
import Footer from "../components/Footer";
import { mentalHealthWork } from "../data/mentalhealthwork";
import MentalHealthCard from "../components/MentalHealthCard";

const MentalHealth = () => {
  // Group items by organisation
  const groupedByOrg = mentalHealthWork.reduce((acc, item) => {
    const existing = acc.find(
      (group) => group.organisation === item.organisation,
    );
    if (existing) {
      existing.items.push(item);
    } else {
      acc.push({ organisation: item.organisation, items: [item] });
    }
    return acc;
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Sidebar page={"Mental Health Work"} />
      <div className="flex-1 px-4 py-4 lg:px-8 lg:py-6 bg-lightBg text-lightText dark:bg-darkBg dark:text-darkText">
        <h1 className="text-3xl lg:text-4xl font-semibold mb-4 text-lightText dark:text-darkText">
          Mental Health Work
        </h1>
        {groupedByOrg.map((group) => (
          <div key={group.organisation} className="mb-6 border-b border-gray-200 pb-4 last:border-0 dark:border-gray-700">
            {group.items.map((item, index) => (
              <MentalHealthCard
                key={index}
                organisation={item.organisation}
                role={item.role}
                duration={item.duration}
                jobscope={item.jobscope}
                showOrganisation={index === 0}
              />
            ))}
          </div>
        ))}
      </div>
      <Footer />
    </div>
  );
};

export default MentalHealth;
